import { render, staticRenderFns } from "./ExaminResultImitate.vue?vue&type=template&id=6f0192f6&scoped=true&"
import script from "./ExaminResultImitate.vue?vue&type=script&lang=js&"
export * from "./ExaminResultImitate.vue?vue&type=script&lang=js&"
import style0 from "./ExaminResultImitate.vue?vue&type=style&index=0&id=6f0192f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0192f6",
  null
  
)

export default component.exports